/** The caller's active MCP tokens (block 27). */
import { useQuery } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useMcpTokens() {
    return useQuery({
        queryKey: queryKeys.mcpTokens.all(),
        queryFn: () => getNookClient().listMcpTokens(),
    });
}
//# sourceMappingURL=use-mcp-tokens.js.map